var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.progress.active
    ? _c(
        "div",
        {
          staticClass: "vks-region-loading-overlay",
          attrs: {
            role: "status",
            "aria-live": "polite",
            "aria-label": "Loading region data",
          },
        },
        [
          _c("div", { staticClass: "vks-region-loading-bubble" }, [
            _c(
              "button",
              {
                staticClass: "vks-region-loading-close",
                attrs: { type: "button", "aria-label": "Close loading panel" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("dismiss")
                  },
                },
              },
              [_c("b-icon", { attrs: { icon: "x", "aria-hidden": "true" } })],
              1
            ),
            _c(
              "ul",
              { staticClass: "vks-region-loading-steps" },
              _vm._l(_vm.progress.steps, function (step) {
                return _c(
                  "li",
                  {
                    key: step.id,
                    staticClass: "vks-region-loading-step",
                    class: `is-${step.status}`,
                  },
                  [
                    _c("b-icon", {
                      staticClass: "vks-region-loading-step-icon",
                      class: _vm.iconClass(step.status),
                      attrs: {
                        icon: "check-circle-fill",
                        "aria-hidden": "true",
                      },
                    }),
                    _c(
                      "span",
                      { staticClass: "vks-region-loading-step-label" },
                      [_vm._v(_vm._s(step.label))]
                    ),
                    step.status === "loading"
                      ? _c(
                          "span",
                          {
                            staticClass: "vks-region-loading-dots",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("span", [_vm._v(".")]),
                            _c("span", [_vm._v(".")]),
                            _c("span", [_vm._v(".")]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }